import { RootState } from '../root.reducers';
import { BackupFileDTO, BackupJobListResponseDTO } from './backup.types';

export const getAllBackupFiles = (state: RootState): BackupFileDTO[] => state.backupFile.backupFiles;

export const getAllBackupRestoreTasks = (state: RootState): BackupJobListResponseDTO => state.backupFile.tasks;

export const getSelectedBackupFiles = (state: RootState): BackupFileDTO | undefined => state.backupFile.selected;
